module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "kaoji-title"
  }, [_vm._v(_vm._s(_vm.row.danwei) + _vm._s(_vm.row.kaojitype))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "基本资料（电子授权证书）",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('QcxjDetailBase')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "成员信息",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('QcxjDetailCommunity')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "数据导出",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('CenterDownload')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "我的考级",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ExameApplyListMine')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "新闻公告",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "社群话题",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "round": "",
      "size": "normal"
    },
    on: {
      "click": _vm.toKaojiNext
    }
  }, [_vm._v("文化布置上传\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "4rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "round": "",
      "size": "normal"
    },
    on: {
      "click": _vm.toContact
    }
  }, [_vm._v("联系 石莎\n      ")])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "show-confirm-button": false,
      "closeOnClickOverlay": true
    },
    model: {
      value: (_vm.bookShow),
      callback: function($$v) {
        _vm.bookShow = $$v
      },
      expression: "bookShow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1751861173166-3.jpg"
    }
  })]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ff07e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetail.vue
// module id = 2574
// module chunks = 0